import { RouteRecordRaw } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import SetpwdView from '../views/SetpwdView.vue'
import AgreementView from '../views/AgreementView.vue'
import SigninView from '../views/SigninView.vue'
import JoinTeamView from '../views/JoinTeamView.vue'
// import SetNameView from '../views/SetName.vue'
import CustomLoginView from '../views/CustomLoginView.vue'
import WechatAuthView from '../views/WechatAuthView.vue'
import UserBindView from '../views/UserBindView.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  // {
  //   path: '/loginlog',
  //   name: 'about',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  // },
  {
    path: '/findpwd',
    name: 'setpwd',
    component: SetpwdView
  },
  {
    path: '/agreement',
    name: 'agreement',
    component: AgreementView
  },
  {
    path: '/signin',
    name: 'signin',
    component: SigninView
  },
  {
    path: '/jointeam',
    name: 'jointeam',
    component: JoinTeamView
  },
  // {
  //   path: '/setname',
  //   name: 'setname',
  //   component: SetNameView
  // }
  {
    path: '/logincube',
    name: 'logincube',
    component: HomeView
  },
  {
    path: '/custom',
    name: 'logincustom',
    component: CustomLoginView,
    meta: {
      title: '绿色建筑多专业协同平台',
      icon: 'favicon2.ico'
    }
  },
  {
    path: '/wechat-auth',
    name: 'wechatauth',
    component: WechatAuthView,
    meta: {
      title: '微信登录',
      icon: 'favicon.ico'
    }
  },
  {
    path: '/user-bind',
    name: 'userbind',
    component: UserBindView,
    meta: {
      title: '用户手机绑定',
      icon: 'favicon.ico'
    }
  }
]

export default routes
